import React from 'react';
import { IPoint } from '@/version-types';
import { PenType } from '../../types';
import boxPenCursor from './assets/box-pen.svg';
import brushPenCursor from './assets/brush-pen.svg';
import lassoPenCursor from './assets/lasso-pen.svg';
import './draw-pen-cursor.less';

const PenCursorMap = new Map<PenType, string>([
    [PenType.BRUSH, brushPenCursor],
    [PenType.BOX, boxPenCursor],
    [PenType.LASSO, lassoPenCursor],
]);

interface IDrawPenCursorProps {
    penType: PenType;
    size: number;
    position: IPoint;
    show?: boolean;
}
/**
 * 通用画笔
 * @returns
 */
export const DrawPenCursor: React.FC<IDrawPenCursorProps> = ({
    penType = PenType.BRUSH,
    size,
    position,
    show = true,
}) => {
    if (!show) return null;

    const isBrushPen = penType === PenType.BRUSH;

    return (
        <div
            className="m-draw-pen-cursor"
            style={{
                cursor: isBrushPen ? 'none' : '',
            }}
        >
            <div
                style={{
                    width: size,
                    height: size,
                    // 涂抹笔需要光标居中
                    transform: isBrushPen ? `translate(-50%, -50%)` : '',
                    left: position.x,
                    top: position.y,
                }}
                className="m-draw-pen-cursor__icon"
            >
                <img src={PenCursorMap.get(penType)} style={{ display: 'block' }} height="100%" width="100%" alt="" />
            </div>
        </div>
    );
};
